import { Paging, Assetsfilter } from '../../core/models/am-helper.model';
import template from './asset-list-client.component.html';
import * as util from '../../core/utilities/am-helper.util';

class AmAssetListClientController {
  constructor($state, amFilterPaginationService, amAssetsService) {
    'ngInject';

    this.assets = [];
    this.filteredAssets = [];
    this.selectedAssets = {};
    this.status = '';
    this.total = 0;
    this.$state = $state;
    this.filterPagingService = amFilterPaginationService;
    this.assetService = amAssetsService;
    this.selectMode = true;
    this.paging = new Paging(7, 1);
    this.total = null;

    this.filter = new Assetsfilter();
    this.propertyKeys = ['name', 'make', 'model', 'year', 'codesSyncStatus'];
    this.addToDataLayer = (data) => window.dataLayer.push(data);
  }

  $onInit() {}

  $onChanges(changes) {
    this.initializeAssets(changes.assetsIn.currentValue);
  }

  $onDestroy() {}

  initializeAssets(assets) {
    if (!assets) return;
    this.assets = assets;
    this.total = this.assets.length;
    this.status = '';
    this.filterPagingService
      .getPaged(this.filter, this.paging, this.assets, this.propertyKeys)
      .then((result) => {
        this.filteredAssets = result.data;
      });
  }

  loadPage(pageNumber) {
    this.paging.currentPage = pageNumber;
    this.getAssetsPaged();
  }

  onTriggerSearch(term) {
    this.filter.query = term ? `*${term}*` : '*';
    this.filteredAssets = this.filterPagingService.filterByTerm(
      this.groups,
      term,
      this.propertyKeys,
    );
    this.paging.reset();
  }

  viewAsset(asset) {
    if (asset) {
      this.$state.go('access-management.asset-view', {
        id: asset.id,
      });
    }
  }

  openSelectAssetsPopup() {
    const alreadyAddedAssets = this.getAssetIds();
    this.assetService
      .openSelectAssetPopup({}, alreadyAddedAssets)
      .then((result) => {
        this.status = 'loading';
        // Filter the assets that were already selected;

        const selected = util.objectToArray(result);
        const resultAdd = selected.filter(
          (selectedAsset) => this.assets.findIndex((asset) => asset.id === selectedAsset.id) === -1,
        );
        // Update the parent controller to add Assets.
        if (resultAdd.length > 0) this.addAssets({ assets: resultAdd });
      })
      .catch(() => {});
  }

  hasSelection() {
    return Object.keys(this.selectedAssets).length > 0;
  }

  numberSelected() {
    return Object.keys(this.selectedAssets).length;
  }

  removeSelected() {
    if (!this.hasSelection()) return;
    this.status = 'loading';
    // Convert the selected assets to array
    const selected = util.objectToArray(this.selectedAssets);
    this.removeAssets({ assets: selected });
    this.selectedAssets = {};
  }

  getAssetsPaged() {
    this.filterPagingService
      .getPaged(this.filter, this.paging, this.assets, this.propertyKeys)
      .then((result) => {
        this.filteredAssets = result.data;
      })
      .catch(() => {});
  }

  updateSearchQuery(query) {
    this.filter.query = query;
    if (query === '') {
      this.getAssetsPaged();
      this.paging.currentPage = 1;
    } else {
      this.filteredAssets = this.filterPagingService.filterByTerm(
        this.assets,
        query,
        this.propertyKeys,
      );
      this.paging.reset();

      this.addToDataLayer({
        event: 'assetSearching',
        data: {
          keyword: query,
          page: this.$state.current.name,
        },
      });
    }
  }

  getAssetIds() {
    return this.assets.map((asset) => asset.id);
  }

  sortBy(sortByEvent) {
    this.filter.clientSideOrderBy = sortByEvent;
    this.getAssetsPaged();
  }
}

export default {
  template,
  controller: AmAssetListClientController,
  controllerAs: 'assetVm',
  bindings: {
    assetsIn: '<',
    assetsOut: '&',
    addAssets: '&',
    removeAssets: '&',
  },
};
